import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Card,
  Table,
  Alert,
  Switch,
  Input,   
  message,
  Popconfirm,
  Button,
  Collapse,
  Form,
  notification,
  Tag
} from "antd";
import PropTypes from "prop-types";
import {
  req_list_lrs_site,
  req_add_lrs_site,
  req_delete_lrs_site,
  req_edit_lrs_site,
  req_list_lrs_equipment,
} from "../../api";
import { usrRole } from "../../utils/dataUtil";

const { Panel } = Collapse;
class SiteModalConfig extends Component {
  state = {
    loading: false,
    item: null,
    items: [],
    subitems: [],
    space: {},
    editMode: true,
    setSiteName: "",
  };

  static propTypes = {
    space: PropTypes.object.isRequired,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
    this.api_list_subitems();
  }

  componentDidMount() {
    this.api_list_items();
  }
  // 遠端數據處理 //////////////////////////////////////////////

  api_list_items = async () => {
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const { RoomCode } = this.props.space;
    const result = await req_list_lrs_site(
      userLevel,
      userCode,
      RoomCode,
      token
    );
    if (result.total) {
      const items = result.total > 0 ? result.data : [];
      this.setState({ items });
    }
  };

  api_list_subitems = async () => {
    const { token, userCode, role } = this.props.user;
    const { RoomCode } = this.props.space;

    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    const result = await req_list_lrs_equipment(
      userLevel,
      userCode,
      RoomCode,
      token
    );
    console.log(result)
    if (result.total) {
      const subitems = result.total > 0 ? result.data : [];
      this.setState({ subitems });
    }
  };

  api_add_item = async (item) => {
    //console.log(item);
    const { token } = this.props.user;
    const result = await req_add_lrs_site(item, token);
    if (result.status === "success") {
      this.api_list_items();
    } else {
      message.info(result.message);
    }
  };

  api_del_item = async (item) => {
    //console.log(item);
    const { Uid } = item;
    const { token } = this.props.user;
    const result = await req_delete_lrs_site(Uid, token);
    if (result.status === "success") {
      message.info(result.message);
      this.api_list_items();
    } else {
      message.info(result.message);
    }
  };

  api_modify_item = async (item) => {
    const { token } = this.props.user;
    //console.log(item);
    const result = await req_edit_lrs_site(item, token);
    if (result.status === "success") {
      // message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "狀態",
        width: 20,
        render: (item) => {
          const { SiteStatus } = item;
          return (
            <>
              <Switch
                checkedChildren="開放"
                unCheckedChildren="不開放"
                defaultChecked={SiteStatus === "OPEN" ? true : false}
                onChange={(e) => this.handle_switch_change(e, item)}
              />
            </>
          );
        },
      },
      {
        title: "座位編號",
        dataIndex: "SiteCode",
        width: 20,
      },
      {
        title: "名稱",
        width: 50,
        responsive: ["md"],
        render: (item) => {
          const { SiteName } = item;
          const { editMode } = this.state;
          return (
            <>
              <Input
                className="form-control"
                placeholder="請輸入座位/隔間名稱"
                disabled={editMode === true ? false : true}
                style={{
                  backgroundColor:
                    editMode === true ? "LightYellow" : "LightGray",
                }}
                defaultValue={SiteName}
                onChange={(e) => this.handle_input_change(e.target.value, item)}
              />
            </>
          );
        },
      },
      {
        title: "操作",
        width: 30,
        render: (item) => {
          const { SiteEquipmentTotal } = item;
          return (
            <>
              <Popconfirm
                title="確定要刪除此筆座位/隔間"
                onConfirm={() => this.handle_show_ui_modal("DELETE", item)}
              >
                <Button type="primary">
                  <i className="fa fa-minus-circle"></i>
                  <span style={{ marginLeft: "4px" }}>刪除</span>
                </Button>
              </Popconfirm>
              {SiteEquipmentTotal > 0 ? (
                <>
                  {" "}
                  <Button
                    onClick={() =>
                      this.handle_show_ui_modal("CONFIG_EQUIPMENT", item)
                    }
                  >
                    <i className="fa fa-cogs"></i>
                    <span style={{ marginLeft: "4px" }}>設備</span>
                  </Button>
                </>
              ) : (
                ""
              )}
            </>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_add_item = (item) => {
    this.api_add_item(item);
  };

  handle_delete_item = (item) => {
    this.api_del_item(item);
  };

  handle_edit_item = (condition, item) => {
    item.condition = condition;
    this.api_modify_item(item);
  };

  handle_input_change(value, item) {
    const { Uid } = item;
    const obj = {
      condition: "BASE",
      SiteName: value,
      Uid: Uid,
    };
    this.handle_edit_item("BASE", obj);
  }

  handle_switch_change(checked, item) {
    const { Uid } = item;
    const SiteStatus = checked === false ? "CLOSE" : "OPEN";
    const obj = {
      condition: "STATUS",
      SiteStatus: SiteStatus,
      Uid: Uid,
    };
    this.handle_edit_item("STATUS", obj);
  }

  handle_show_ui_modal = (type, item) => {
    //console.log(item);
    switch (type) {
      case "ADD":
        this.setState({ isShowAddModal: true });
        break;
      // case "EDIT":
      //   this.setState({ isShowEditModal: true });
      //   break;
      case "DELETE":
        //console.log(item);
        const target = {
          Uid: item.Uid,
          condition: "GUID",
        };
        this.handle_delete_item(target);
        break;
      case "CONFIG_EQUIPMENT":
        //this.setState({ isShowConfigEquipmentModal: true });

        const { subitems } = this.state;
        const selectedItems = [];
        //console.log(subitems)
        subitems.forEach((element) => {   
          if (
            element.SpaceSiteNId.toString() === item.SpaceSiteNId.toString()
          ) {
            selectedItems.push(element);
          }
        });
        //console.log(selectedItems)
       this.open_notification(selectedItems);
        break;
      default:
    }
    this.setState({ item: item });
  };

  handle_form_finish = (values) => {
    const { SiteCode, SiteName } = values;
    const { RoomCode } = this.props.space;
    //console.log(values);
    const item = {
      RoomCode: RoomCode,
      SiteCode: SiteCode,
      SiteName: SiteName,
      SiteStatus: "OPEN",
    };
    this.api_add_item(item);
  };

  open_notification = (items) => {
    if(items.length > 0){
      const { SiteName } = items[0];
      const key = `open${Date.now()}`;
      const btn = (
        <Button
          type="primary"
          size="small"
          onClick={() => notification.close(key)}
        >
          關閉
        </Button>
      );
      notification.open({
        message: <div>{SiteName}設備清單</div>,
        description: <div>
                         {items.map((item) => (
                          <Tag color={item.EquipmentStatus ==="NORMAL" ? "green": "orange"}>{item.EquipmentName}</Tag>
                        ))}
  

        </div>,
        btn,
        key,
      });

    }

  };

  //////////////////////////////////////////////////////////

  render() {
    const { loading, items } = this.state;
    const { RoomCode, RoomTwName } = this.props.space;
    return (
      <Card>
        <div>
          <Alert
            message={
              <div style={{ color: "red", fontSize: "1.3em" }}>
                ({RoomCode}){RoomTwName}
              </div>
            }
            type="success"
          />
        </div>
        <Collapse accordion>
          <Panel
            header={
              <>
                <i className="fa fa-plus-square"></i> 新增座位/隔間
              </>
            }
            key="1"
          >
            <Form layout={"inline"} onFinish={this.handle_form_finish}>
              <Form.Item
                label="編號"
                name="SiteCode"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder="請輸入座位/隔間編號" />
              </Form.Item>
              <Form.Item
                label="名稱"
                name="SiteName"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder="請輸入座位/隔間名稱" />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  <i className="fa fa-plus-circle"></i>{" "}
                  <span style={{ marginLeft: "4px" }}>新增</span>
                </Button>
              </Form.Item>
            </Form>
          </Panel>
        </Collapse>
        <Table
          dataSource={items}
          columns={this.columns}
          loading={loading}
          rowKey="Uid"
          scroll={{ y: 460 }}
          width="70%"
          pagination={false}
        />
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(SiteModalConfig);
